import { render, staticRenderFns } from "./LegajoInfo.vue?vue&type=template&id=1fb76818"
import script from "./LegajoInfo.vue?vue&type=script&lang=js"
export * from "./LegajoInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/tomi/Projects/ingeniAR/rrhh/Frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1fb76818')) {
      api.createRecord('1fb76818', component.options)
    } else {
      api.reload('1fb76818', component.options)
    }
    module.hot.accept("./LegajoInfo.vue?vue&type=template&id=1fb76818", function () {
      api.rerender('1fb76818', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Legajos/LegajoInfo.vue"
export default component.exports